import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import jumboimage from './images/jumbotronbg_small.jpg';
import Card from './card';
import '../scss/home.scss';

function Home(props) {
  return (
    <div>
      <Jumbotron>
        <div className="banner-content text-center">
          <div class="background-image">
            <img src={jumboimage} alt="Our Mission"/>
          </div>
          <div class="jumbotron-content">
            <div className="jumbotron-title">Our Mission</div>
            <p>Electra Technical Sales has been a leading Manufacturer’s Representative in the Pacific NW since 1993. We have continued to grow and evolve in the ever changing electronics market place. Our mission is to provide the best service to the manufacturers we represent, and the clients we serve.</p>
            <p>We focus on strategically staying in alignment with our suppliers to collaboratively develop, market, and sell into clients that design and build in our region. We drive these efforts with a combination of direct sales as well as managing sales through distribution for our lines that market through those channels.</p>
          </div>
        </div>
      </Jumbotron>

      <div className="description-tile-container row">
        <div className="col-12 col-md-6 col-lg-4 description-tile">
          <div className="content">
            <div className="description-title">Relationships</div>
            <p>A key value we provide is the trusted relationships we have developed and continued to nurture in the local markets, as well as the many supplier and channel partner relationships we maintain.</p>
            <p>Our reputation throughout our network is critical to our continued success as a business.  In addition, our experience and relationships in supply chain management ensure that our clients are successful throughout the entire development process.</p>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 description-tile">
          <div className="content">
            <div className="description-title">Market Knowledge</div>
            <p>Understanding and connecting our principles with our market is key to our success.  Providing access to the customer by knowing the customer’s needs and solving problems.</p>
            <p>Our sales team is dedicated to deliver a higher level of insight and support to our clients and provide the most cost effective solution to a customer’s needs.</p>
            <p>We achieve this through understanding the current market influences for our region, coupled with continuing to stay abreast of new client markets as well as new clients opening or moving to the area.</p>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 description-tile">
          <div className="content">
            <div className="description-title">Technical</div>
            <p>Electra is extensively trained in the latest technologies, markets, and products. We blend the key value propositions from our suppliers with key customer needs  for our mutual clients.</p>
            <p>Clients and suppliers value our expertise to help them mitigate development risks and increase product value.  Our conversations with clients focus on innovative technology solutions driving the development process from conceptual design to validated production ready hardware.</p>
            <p>We ensure that we coordinate product ramp information to both customers and suppliers to help provide the support for a smooth execution to production.</p>
          </div>
        </div>
      </div>

      <div className="card-holder mx-auto row">
        { props.visablePages.linecards ? <Card displayText="Line Cards" buttonText="View Our Line Cards" url="/linecard" /> : '' }
        { props.visablePages.contactus ? <Card displayText="Get In Touch" buttonText="Contact Us" url="/contactus" /> : '' }
      </div>
    </div>
  );
}

export default Home;
